import { render } from "./Thumbnail.vue?vue&type=template&id=592d78a0&scoped=true"
import script from "./Thumbnail.vue?vue&type=script&lang=js"
export * from "./Thumbnail.vue?vue&type=script&lang=js"

import "./Thumbnail.vue?vue&type=style&index=0&id=592d78a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-592d78a0"

export default script